// Auth pages links
export const AUTH = '/auth';
export const LOGIN = `${AUTH}/login`;
export const SIGN_UP = `${AUTH}/sign-up`;
export const COMPLETE_REGISTRATION = `${AUTH}/complete-registration`;
export const COMPLETE_PERSONAL_DATA = `${AUTH}/complete-personal-data`;
export const SET_NEW_PASSWORD = `${AUTH}/set-new-password`;
export const VERIFY_EMAIL = `${AUTH}/verify-email`;
export const VERIFY_PHONE_NUMBER = `${AUTH}/verify-phone-number`;

// Common link
export const HOME = '/';

// App links
export const APP = '/app';
export const APPLICATIONS = `${APP}/applications`;
export const CREATE_NEW_APPLICATIONS = `${APPLICATIONS}/create-new`;
export const APPLICATION_DETAIL = `${APPLICATIONS}/$applicationId`;
